import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/app/components';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { VariableCrudManagerService, BaseVariableService, VariablesTemplateComponent } from '@wms/variables';

@Component({
  standalone: true,
  selector: 'wms-notification-action-creation',
  templateUrl: './notification-action-creation.component.html',
  styleUrls: ['./notification-action-creation.component.less'],
  imports: [CommonModule, TooltipModule, VariablesTemplateComponent]
})
export class NotificationActionCreationComponent extends BaseComponent implements OnInit {
  @Input() selectedVarService: any;

  constructor(public varManagerService: VariableCrudManagerService, public baseVariableService: BaseVariableService) { 
    super();
  }

  ngOnInit(): void {
  }

  handleModelChange(changeObj: any) {
    this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelObj[this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelKey] = changeObj.$event;  
    this.selectedVarService.__onPropertyChange(changeObj.propertyName, changeObj.$event);
  }
}
